import React, {useState} from "react"
import sanitizeHtml from 'sanitize-html';
import CountUp from 'react-countup';
import sanitizeOptions from "../../helper/sanitizeOptions";

const ContentListItem = ({item, useCounter}) => {
    const sanitizeOpt = sanitizeOptions();
    const [title, setTitle] = useState(false);
    const getNumberFromString = (string) => {
        return Number(string.match(/\d+/) && string.match(/\d+/)[0]) || string;
    };

    const Counter = () => {
        return (
            title? title :
                <CountUp
                    end={getNumberFromString(item.title)}
                    duration={1}
                    onEnd={() =>{
                        setTitle(item.title)
                    }}
                />
        )
    };

    return (
        <li>
            {!!item.title && (
                <span className={'title'}>
                    {
                        useCounter
                            ? <Counter/>
                            : item.title
                    }
                </span>
            )}
            <span dangerouslySetInnerHTML={{ __html: sanitizeHtml(item.text, sanitizeOpt.title) }}/>
        </li>
    )
};

export default ContentListItem
